import { Link } from "react-router-dom";
import { ShieldCheck, Phone, Mail, MapPin } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function Footer() {
  const { settings } = useApp();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex items-center bg-white rounded-xl px-3 py-2 mb-4">
              <img src="/logo.png" alt="Faridabad Properties" className="h-9 w-auto" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">Faridabad ki selected properties — personally verified, honestly priced. Quality over quantity.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/properties" className="hover:text-indigo-400">All Properties</Link></li>
              <li><Link to="/urgent-sale" className="hover:text-indigo-400">Urgent Sale</Link></li>
              <li><Link to="/price-reduced" className="hover:text-indigo-400">Price Reduced</Link></li>
              <li><Link to="/new-listings" className="hover:text-indigo-400">New Listings</Link></li>
              <li><Link to="/locations" className="hover:text-indigo-400">Sector Explorer</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-indigo-400">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-indigo-400">Contact</Link></li>
              <li><Link to="/blog" className="hover:text-indigo-400">Property Guides</Link></li>
              <li><Link to="/book-site-visit" className="hover:text-indigo-400">Book Site Visit</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-indigo-400">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-indigo-400">Terms &amp; Conditions</Link></li>
              <li><Link to="/disclaimer" className="hover:text-indigo-400">Disclaimer</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-indigo-400">Cookie Policy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-indigo-400" /> {settings.phone || "+91 99999 99999"}</li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-indigo-400" /> {settings.email || "contact@faridabadproperty.in"}</li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-indigo-400" /> {settings.office_address || "Faridabad, Haryana"}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-10 pt-6 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-2">
          <span>© 2026 {settings.site_name || "Faridabad Property Vault"}. All rights reserved.</span>
          <span>Price assessments are informational opinions, not formal valuations.</span>
        </div>
      </div>
    </footer>
  );
}
